import React  from "react"

export const Home = () => {
  return (
    <div className="relative flex-1 flex flex-col bg-white shopping-cart__content">
       <iframe src="https://upos.vn/" frameborder="0" style={{height: '100vh'}}></iframe>
    </div>
  )
}
